import './styles.css';

import React, { Component } from 'react';
import Content from "../../content/Content";
import HeaderText from "../../components/HeaderText/HeaderText";
import LandingPageHeader from "../../components/LandingPageHeader/LandingPageHeader";
import InformationLabel from "../../components/InformationLabel/InformationLabel";
import InformationLabelContentList from "../../components/InformationLabelContentList/InformationLabelContentList";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import Footer from "../../components/Footer/Footer";
import Constants from "../../constants/Constants";
import {checkAuth} from "../../services/BaseServiceHandler";
import DataPanelLoadingView from "../../components/LoadingViews/DataPanelLoadingView";


class TermsAndConditions extends Component {

    constructor(props){
        super(props);

        this.state = {
            isAuthenticatedUser: false,
            serverCallStatus : Constants.REQUEST_STATS.PENDING,
        };
        this.refGetInTouch=null;
    }

    componentWillMount() {
        // window.scrollTo(0, 0);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        checkAuth(this.onCheckAuthSuccess, this.onCheckAuthFailure);
    }

    onCheckAuthSuccess = (authData) => {
        if(authData) {
            this.setState({
                isAuthenticatedUser: true,
                serverCallStatus: Constants.REQUEST_STATS.SUCCESS
            });
        }
        else {
            this.setState({
                serverCallStatus: Constants.REQUEST_STATS.SUCCESS
            });
        }
    };

    onCheckAuthFailure = () => {
        this.setState({
            serverCallStatus: Constants.REQUEST_STATS.SUCCESS
        });
    };

    onClickGetInTouch = () => {
        window.scrollTo(0, this.refGetInTouch.offsetTop ? this.refGetInTouch.offsetTop-60 : 0);
    };

    getDataView = () => {
        let customStyleHeaderText = {
            background: '#0028ea',
            color: '#FFF'
        };

        if(this.state.isAuthenticatedUser) {
            customStyleHeaderText = {
                background: '#F5F5F5',
                color: '#000'
            }
        }

        return (
            <div className="terms_and_conditions">

                <LandingPageHeader
                    isAuthenticatedUser = {this.state.isAuthenticatedUser}
                    onClickGetInTouch = {this.onClickGetInTouch}
                    {...this.props}
                />

                <div style = {{paddingTop: '60px'}}></div>

                <HeaderText
                    headerText = {Content.HEADER_TEXT.TERMS_AND_CONDITIONS}
                    customStyleHeaderText = {customStyleHeaderText}
                />

                <div className="tac-wrapper">

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.HEADER}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 22px/1.4 GillSans Semi Bold'
                        }}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_1}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_1.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_2}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_2.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_3}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_3.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_4}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_4.EXPLANATION_1, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_4.EXPLANATION_2, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_4.EXPLANATION_3, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_4.EXPLANATION_4]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_5}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_5.EXPLANATION_1, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_5.EXPLANATION_2, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_5.EXPLANATION_3, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_5.EXPLANATION_4, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_5.EXPLANATION_5, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_5.EXPLANATION_6]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_6}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_6.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_7}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_7.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_8}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_8.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_9}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_9.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_10}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_10.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_11}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_11.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_12}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_12.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_13}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_13.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_14}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_14.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_15}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_15.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_16}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_16.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_17}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_17.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_18}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_18.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_19}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_19.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_20}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_20.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_21}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_21.EXPLANATION_1, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_21.EXPLANATION_2]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_22}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_22.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_23}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_23.EXPLANATION_1, Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_23.EXPLANATION_2]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_24}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_24.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_25}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_25.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                    <InformationLabel
                        infoLabel = {Content.TERMS_AND_CONDITIONS.LABEL.LABEL_26}
                        customStyleInformationLabelNonClickable = {{
                            font: 'normal 15px/22px GillSans Bold'
                        }}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.TERMS_AND_CONDITIONS.LABEL_EXPLANATION.LABEL_26.EXPLANATION_1]}
                        customStyleInformationLabelContentList = {{
                            font: 'normal 15px/22px GillSans Regular'
                        }}
                        removeSecondLineBreak = {true}
                    />

                </div>
                
                <div ref={ref => this.refGetInTouch=ref}></div>
                <GetInTouch/>

                <Footer/>

            </div>
        )
    };

    getLoadingPage = ()=>{
        return(
            <DataPanelLoadingView/>
        );
    };


    getViewTobeRendered = (serverCallStatus) =>{
        let renderView = null ;

        switch (serverCallStatus){
            case 1:
                renderView =  this.getLoadingPage();
                break;
            case 2:
                renderView = this.getDataView();
                break;
            default:
                break;
        }
        return renderView;
    };

    render() {

        return this.getViewTobeRendered(this.state.serverCallStatus)

    }

}

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./src/scenes/TermsAndConditions/TermsAndConditions.js